function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m18.6353 55.9056c10.2919 10.292 26.9785 10.292 37.2704 0 10.292-10.2919 10.292-26.9784 0-37.2704-10.2919-10.29193-26.9785-10.29193-37.2704 0-10.29194 10.2919-10.29194 26.9785 0 37.2704zm1.6205-1.6204c9.3969 9.397 24.6325 9.397 34.0295 0s9.397-24.6325 0-34.0295-24.6326-9.397-34.0295 0c-9.397 9.397-9.397 24.6325 0 34.0295zm5.6715-26.7375 1.6205-1.6205 9.7227 9.7228 9.7227-9.7228 1.6205 1.6205-9.7227 9.7227 9.7227 9.7227-1.6205 1.6205-9.7227-9.7227-9.7227 9.7227-1.6205-1.6205 9.7228-9.7227z",
  fill: "#000",
  fillRule: "evenodd"
});

var SvgCircleClose = function SvgCircleClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 75,
    viewBox: "0 0 75 75",
    width: 75,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircleClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circle-close.c94f01c6.svg";
export { ForwardRef as ReactComponent };